import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
} from "@mui/material";
import { ProductoWProps } from "../Producto";
import ProductoActions from "../ProductoActions";
import ButtonDesplegable from "../../../../components/Common/ButtonDesplegable";
import DesplegableRubrosProducto from "../DesplegableRubrosProducto";
import { useContext } from "react";
import { ProductosAdminContext } from "../../context/productos.context";
import { format } from "date-fns";

const CardProducto = ({
  producto,
  rubros,
  changingEstado,
  loadingRubros,
  isDefinitivelyDeleting,
  cambiarRubro,
  isSelected,
  setIsSelected,
}: ProductoWProps) => {
  const { setEditProductId, setIdLocalEditing } = useContext(ProductosAdminContext);
  return (
    <Card
      sx={{
        width: 350,
        height: 500,
        display: "flex",
        flexDirection: "column",
        border: "2px solid",
      }}
    >
      <CardActionArea
        onClick={() => {
          setIdLocalEditing(producto.idLocal);
          setEditProductId(producto.idProducto);
        }}
      >
        <CardMedia
          component={"img"}
          loading="lazy"
          sx={{ height: 200, objectFit: "scale-down" }}
          image={producto.urlFoto}
          title={producto.nombre}
        />
      </CardActionArea>
      <CardHeader
        sx={{
          backgroundColor:
            producto.aprobado && !producto.pausado && !producto.vencido
              ? "#b3faa8"
              : producto.rechazado
              ? "#ffaeba"
              : producto.pausado || producto.vencido
              ? "#ddd"
              : "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        action={
          <Box sx={{ color: "text.secondary" }}>
            <ButtonDesplegable color="inherit" variant="text">
              <ProductoActions
                changingEstado={changingEstado}
                isDefinitivelyDeleting={isDefinitivelyDeleting}
                producto={producto}
              />
            </ButtonDesplegable>
          </Box>
        }
        title={producto.nombre}
        titleTypographyProps={{ variant: "body1" }}
        subheader={`${producto.nombreLocal} - (${producto.idLocal})`}
        subheaderTypographyProps={{ variant: "body2" }}
      />
      <CardContent>
        <Typography variant="body2" color="darkblue">
          {producto.precioFormateado.split("<br>").map(
            (linea, i) =>
              linea.length > 0 && (
                <span key={i}>
                  {linea}
                  <br />
                </span>
              )
          )}
        </Typography>
        <Typography
          variant="body2"
          color="darkblue"
          style={{ whiteSpace: "break-spaces" }}
        >
          {`Pub: ${format(
            new Date(producto.fechaPublicacion),
            "dd/MM/yyyy HH:mm"
          )}\nVto: ${format(
            new Date(producto.fechaVencimiento),
            "dd/MM/yyyy"
          )}`}
        </Typography>
        <Typography variant="body2" color="gray" sx={{ marginTop: "10px" }}>
          {producto.flags}
        </Typography>
      </CardContent>
      {/* Se alinea verticalmente al final del rubro */}
      <Box sx={{ flexGrow: 1 }} />
      <CardActions>
        <DesplegableRubrosProducto
          rubros={rubros}
          loading={loadingRubros}
          onChange={cambiarRubro}
          nombreRubro={producto.nombreRubro}
          idActual={producto.idRubro}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
        />
      </CardActions>
    </Card>
  );
};

export default CardProducto;
